import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=2afe39c9&scoped=true&"
import script from "./IntegrationCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./IntegrationCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=2afe39c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe39c9",
  null
  
)

export default component.exports